import { defineComponent as t, createBlock as r, openBlock as c, unref as s, mergeProps as i, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as l } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceConfianza",
  __name: "IconReassuranceConfianza",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (d, a) => (c(), r(s(l), i(o, { "view-box": "0 0 48 48" }), {
      default: p(() => a[0] || (a[0] = [
        e("g", { "clip-path": "url(#s971dia)" }, [
          e("path", {
            "fill-rule": "evenodd",
            d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48m0 9C15.715 9 9 15.715 9 24s6.715 15 15 15 15-6.715 15-15a1.267 1.267 0 0 0-1.27-1.27A1.267 1.267 0 0 0 36.46 24c0 6.885-5.575 12.46-12.46 12.46-6.885 0-12.46-5.583-12.46-12.46 0-6.885 5.575-12.46 12.46-12.46a1.267 1.267 0 0 0 1.27-1.27A1.267 1.267 0 0 0 24 9m0 18.9a3.902 3.902 0 0 1-3.9-3.9c0-2.152 1.748-3.9 3.9-3.9s3.9 1.748 3.9 3.9c0 2.16-1.748 3.9-3.9 3.9m0-10.405a6.509 6.509 0 0 0-6.513 6.513A6.51 6.51 0 0 0 24 30.521a6.507 6.507 0 0 0 6.505-6.513A6.502 6.502 0 0 0 24 17.495m-10.793 6.513c0-5.963 4.83-10.793 10.793-10.793 5.955 0 10.793 4.83 10.785 10.801a1.302 1.302 0 1 1-2.605 0 8.183 8.183 0 0 0-8.18-8.18 8.173 8.173 0 0 0-8.18 8.18 8.178 8.178 0 0 0 8.18 8.18 1.302 1.302 0 1 1 0 2.605c-5.963 0-10.793-4.838-10.793-10.793",
            "clip-rule": "evenodd"
          })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "s971dia" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
